<template>
  <div>
    <div class="flex items-end gap-2 mr-[20px] pt-[25px]">
      <h1
        class="font-normal text-slate-900"
        :class="!minified ? 'text-lg lg:text-3xl' : 'text-base lg:text-[1.675rem] leading-[30px]'"
      >
        {{ formattedEmissions }}
      </h1>
      <span class="text-xs lg:text-sm font-normal mt-0.5 align-baseline text-[#707C8ECC] no-localize-translate">tCO<sub>2</sub>e</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopEmittingLabelTotal',

  props: {
    emissions: {
      type: Number,
      required: true,
      default: 0,
    },
    minified: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    formattedEmissions() {
      return thousands(this.emissions, 2, true)
    },
  },
}
</script>
